import Icon from "@mui/icons-material/HandshakeTwoTone";
import List from "./list";
import Edit from "./edit";
import Create from "./create";

export default {
  list: List,
  edit: Edit,
  create: Create,
  icon: Icon,
  label: "Sponsors",
  options: { label: "Sponsors" },
  name: "sponsors",
};
